<template>
    <rkm-form>
        <rkm-row>
            <rkm-col cols="12">
                <rkm-form-radio-group
                    buttons
                    class="classificacao-risco"
                    v-model="data.model.classificacaoRiscoId"
                >
                    <rkm-form-radio
                        v-for="classificacaoRisco in data.form.classificacoesRisco"
                        v-bind:key="classificacaoRisco.id"
                        :style="'color: ' + classificacaoRisco.cor"
                        :value="classificacaoRisco.id"
                        :disabled="isDisabled()"
                    >
                        <span class="classificacao-risco-cor">
                            {{ classificacaoRisco.corNome }}
                        </span>

                        <span class="classificacao-risco-nome">
                            {{ classificacaoRisco.nome }}
                        </span>
                    </rkm-form-radio>
                </rkm-form-radio-group>
            </rkm-col>
        </rkm-row>
    </rkm-form>
</template>

<script>
export default {
    methods: {
        isDisabled() {

            const isAuxiliarTecnicoEnfermagem = this.data.additionals
                && this.data.additionals.isAuxiliarTecnicoEnfermagem;
            const isAtendimentoTriagemSemEnfermeiro = this.funcionalidade === 'atendimento-triagem'
                && this.data.additionals && !this.data.additionals.isEnfermeiro;

            return isAuxiliarTecnicoEnfermagem || isAtendimentoTriagemSemEnfermeiro;
        }
    },
    props: {
        data: { type: Object, required: true },
        funcionalidade: { type: String, default: null }
    },
}
</script>

<style scoped>
.classificacao-risco .btn {
    padding: 1rem 1.5rem 1rem 50px;
    position: relative;
    border: 1px solid rgb(166 169 175);
    background: none;
    margin: 2px;
    border-radius: 3px;
    transition: border-color 0.3s;
    height: auto;
    flex-direction: column;
    align-items: flex-start;
}
.classificacao-risco .btn:before {
    content: '';
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    opacity: 0;
    background: currentColor;
    transition: opacity 0.3s;
}
.classificacao-risco .btn:after {
    content: '';
    position: absolute;
    top: 50%;
    left: 20px;
    transform: translateX(-50%) translateY(-50%);
    width: 15px;
    height: 15px;
    border: 3px solid #FFF;
    background: none;
    box-shadow: 0px 0px 0 2px rgb(166 169 175), 0px 0px 0 0px rgb(166 169 175);
    border-radius: 100%;
    transition: box-shadow 0.3s, background 0.3s;
    z-index: 2;
}
.classificacao-risco .btn span{
    display: block;
    text-align: left;
    line-height: 1;
}
.classificacao-risco-cor{
    font-size: 10px;
    text-transform: uppercase;
}
.classificacao-risco-nome{
    font-weight: 400;
    color: #495057;
    font-size: 1.15em;
}
.classificacao-risco .btn:hover:after {
    box-shadow: 0px 0px 0 2px currentColor, 0px 0px 0px 0px currentColor;
}
.classificacao-risco .btn.active {
    border-color: currentColor;
    box-shadow: 0px 0px 0 0.5px currentColor, 0px 0px 15px -7px currentColor;
}
.classificacao-risco .btn.active:before {
    opacity: 0.15;
}
.classificacao-risco .btn.active:after {
    background: currentColor;
    box-shadow: 0px 0px 0 2px currentColor, 0px 0px 10px 0px currentColor;
}
</style>